import React from 'react';
import RecentReviews from '../components/RecentReviews';
import FAQ from '../components/FAQ';

export default function TestPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-emerald-50 to-orange-50 p-8">
      <RecentReviews />
      <FAQ />
    </div>
  );
}